import { Link } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

export default function Forbidden() {
  return (
    <div className="bg-slate-950 text-white min-h-[70vh] flex items-center justify-center py-20 px-4">
      <PageMeta
        title="403 - Adgang nægtet - Duus Rustfri"
        description="Adgang nægtet. Gå tilbage til forsiden eller kontakt Duus Rustfri."
      />

      <div className="max-w-xl text-center space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-slate-800 text-amber-400 text-xs font-mono font-semibold uppercase">
          Fejl 403 · Adgang begrænset
        </div>

        <h1 className="text-4xl sm:text-6xl font-black tracking-tight text-white">
          Adgang nægtet
        </h1>

        <p className="text-slate-400 text-base sm:text-lg leading-relaxed">
          Du har ikke tilladelse til at tilgå den efterspurgte ressource. Benyt navigationen herunder for at finde tilbage til en offentlig side.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 w-full sm:w-auto">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-sky-600 to-blue-700 hover:from-sky-500 hover:to-blue-600 text-white font-semibold text-sm shadow-lg transition text-center"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 font-semibold text-sm transition text-center"
          >
            <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
